import {
    RECEIVE_CREATE_SKILL,
    REQUEST_CREATE_SKILL,
    UPDATE_CREATE_SKILL_VALUES,
    CLEAR_CREATE_SKILL_VALUES
} from "../constants/actionTypes"


const initialState = {
    skillName: "",
    skillGroup: "",
    skillType: "",
    skillNameValid: false,
    skillGroupValid: false,
    skillTypeValid: false,
    showModal: false,
    hideModal: false,
    isRequesting: false
}

export const createSkillData = (state = initialState, action) => {
    switch(action.type) {
        case UPDATE_CREATE_SKILL_VALUES:{
            let newState = {
                ...state,
                ...action.values
            };

            return newState;
        }

        case REQUEST_CREATE_SKILL:{
            return {
                ...state,
                isRequesting: true
            }
        }

        case CLEAR_CREATE_SKILL_VALUES:{
            return initialState;
        }

        case RECEIVE_CREATE_SKILL:{
            return {
                ...state,
                hideModal: true,
                isRequesting: false
            }
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/createSkillData.js